<template>
    <div class="scrollable-container">
        <div>
            <div class="search-bar-gray d-flex">
                <v-btn @click="gettingData"><v-icon>mdi-magnify</v-icon></v-btn>
                <v-text-field v-model="searchVal" solo :label="$t('res_Label_SearchPlaceHolder')" @keydown.enter="searchFieldKeydownHandler"></v-text-field>
                <div class="custom-icon-wrapper" v-if="searchVal != ''">
                    <v-icon @click="reset()">custom-icon mdi-close</v-icon>
                </div>
            </div>
            <v-treeview class="mt-4" :load-children="gettingData" :items="items">
                <template v-slot:label="{ item }">
                    <div class="d-flex align-items-center">
                        <div v-if=" !item.readOnly ">
                            <v-checkbox v-model="value" :value="item" dense></v-checkbox>
                        </div>
                        <div>
                            <span v-if="item.childrenCount != null && item.childrenCount != undefined && item.childrenCount > 0" class="v-treeview-node__inner-label mr-1">{{ item.name }}</span>
                            <span v-else class="v-treeview-node__inner-label v-treeview-leaf mr-1">{{ item.name }}</span>
                        </div>
                        <div v-if="isForAddEditDeleteControl" class="ml-auto">
                            <button class="ml-1 mr-1" @click="DeleteFilingClassificationPlan(item)"><v-icon class="light">mdi-trash-can-outline</v-icon></button>
                            <button class="ml-1 mr-1" @click="openAddEditDialog(item,'Edit')"><v-icon class="light">mdi-pencil</v-icon></button>
                            <button class="ml-1 mr-3" @click="openAddEditDialog(item,'Add')"><v-icon class="light">mdi-plus-circle-outline</v-icon></button>
                        </div>
                    </div>
                </template>
            </v-treeview>
            <div v-if="isForAddEditDeleteControl" class="d-flex justify-content-end mr-4 mt-2">
                <v-btn color="primary" @click="openAddEditDialog(null,'Add')">{{ $t("res_label_AddNewPlan") }}</v-btn>
            </div>
            <div v-if="!isForAddEditDeleteControl" class="dialog-footer d-flex align-items-center justify-content-end gap-3 mt-2">
                <v-btn color="light-blue" @click="closeFilingClassificationPlanDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                <v-btn color="primary" :disabled="AddDisabled" @click="handleSelectFromFilingClassificationTree">{{ $t("res_ButtonText_Add") }}</v-btn>
            </div>
            <!---------------AddEdit Dialog------------------------>
            <v-dialog v-model="showAddEditDialog" max-width="700px" min-height="700px">
                <v-card>
                    <v-card-title>{{ addEditResourceDialog }}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-label>{{ $t('res_Label_Name') }}*</v-label>
                                <v-text-field v-model="addEditDeleteDialogObject.name" label solo></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-label>{{ $t('res_Label_Code') }}*</v-label>
                                <v-text-field v-model="addEditDeleteDialogObject.code" label solo></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox v-model="addEditDeleteDialogObject.readOnly" :label=" $t('res_Label_ReadOnly')"  ></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-btn class="primary" style="min-width: 100px !important" @click="AddEditFilingClassificationPlan()" :disabled="GetDisabledAddFilingClassificationPlan()"> {{ addEditResourceDialog }} </v-btn>
                        <v-btn class="light-blue" style="min-width: 100px !important" @click="closeAddEditDialog()"> {{ $t("res_ButtonText_Close")}} </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div>
    </div>
</template>

<script>
    import constants from '@/assets/js/constants.js'
    import MultiSelect from 'vue-multiselect'
    import axios from 'axios';
    import * as utils from '@/assets/js/common.js'
    import FilingClassificationPlanSelector from '@/components/FilingClassificationPlanSelector.vue'

    export default {
        name: 'FilingClassificationPlanTree',
        components: { FilingClassificationPlanSelector },
        props: {
            mode: { type: Number, default: 3 },
            allowSelect: { type: Boolean, default: true },
            isForAddEditDeleteControl: { type: Boolean, default: false },
            showHierarchicalData: { type: Boolean, default: false },
            structureId: Number,
        },
        data: () => ({
            constants: constants,
            utils: utils,
            searchVal: "",
            items: [],
            openNodes: [],
            value: null,
            AddDisabled: true,
            filingClassificationPlanMode: {
                FilingPlanMode: 1,
                ClassificationPlanMode: 2,
                BothPlanModes: 3
            },
            //-------AddEditDelete Prop
            showAddEditDialog: false,
            addEditDeleteDialogObject: {},
            addEditResourceDialog: "",
            reloadFlag: false,
        }),
        mounted() {
            this.reset();
        },
        watch: {
            value(newVal) {
                if (newVal != null && newVal != undefined)
                    this.AddDisabled = false
                else
                    this.AddDisabled = true
            },
            items(newVal) {
                this.items = newVal
            }
        },
        methods: {
            async gettingData(parent) 
            {
                let parentId = parent != undefined && parent != null ? parent.id : ''
                window.showLoading();
                if (parent != undefined)
                    parent.loading = true;

                var methodName = "Admin/GetAllFilingClassificationPlans"
                if (this.showHierarchicalData)
                    methodName = "Admin/GetAllFilingClassificationPlansHierarchical"

                await axios.get(constants.baseApiUrl + methodName + '?search=' + this.searchVal + '&mode=' + this.mode
                    + '&parentId=' + parentId + '&structureId=' + (this.structureId > 0 ? this.structureId : ''))
                    .then(res => 
                    {
                        if (res.data != undefined && res.data != null && res.data.length > 0)
                            res.data.forEach(item => 
                        {
                                item.id = item.id.toString()
                                item.children = [];
                            });

                        if (parentId != '' && parentId > 0) {
                            parent.children = res.data;
                            parent.loading = false;
                        }
                        else 
                        {
                            this.items = res.data
                        }
                        this.value = null;
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            },
            searchFieldKeydownHandler() {
                this.gettingData()
            },
            handleSelectFromFilingClassificationTree() {
                this.$emit('handleSelectedChanged', this.value);
                this.closeFilingClassificationPlanDialog();
            },
            reset() {
                this.searchVal = '';
                this.items = [];
                this.gettingData();
            },
            closeFilingClassificationPlanDialog() {
                this.$emit('close-dialog');
            },
            //------------------------------------------
            //------------AddEditDelete Actions---------
            openAddEditDialog(item, addEditDeleteMode) {
                if (addEditDeleteMode == 'Add') {
                    this.addEditResourceDialog = this.$t('res_ButtonText_Add')
                    this.addEditDeleteDialogObject = {};
                    this.addEditDeleteDialogObject.structureId = this.structureId;
                    if (this.mode == this.filingClassificationPlanMode.FilingPlanMode)
                        this.addEditDeleteDialogObject.IsFiling = true;
                    else if (this.mode == this.filingClassificationPlanMode.ClassificationPlanMode)
                        this.addEditDeleteDialogObject.IsClassification = true;
                    else {
                        this.addEditDeleteDialogObject.IsFiling = true;
                        this.addEditDeleteDialogObject.IsClassification = true;
                    }
                    if (!utils.CheckIfNullOrEmpty(item))
                        this.addEditDeleteDialogObject.parentId = item.id;
                    this.addEditDeleteDialogObject.structureId = this.structureId;
                }
                else if (addEditDeleteMode == 'Edit') {
                    this.addEditResourceDialog = this.$t('res_ButtonText_Add')
                    this.addEditDeleteDialogObject = item;
                }
                this.showAddEditDialog = true;
            },
            AddEditFilingClassificationPlan() {
                this.AddEditDeleteObjectService(this.addEditDeleteDialogObject);
            },
            DeleteFilingClassificationPlan(item) {
                this.addEditDeleteDialogObject = item;
                this.$set(this.addEditDeleteDialogObject, 'isDeleted', true);
                this.AddEditDeleteObjectService(this.addEditDeleteDialogObject);
            },
            async AddEditDeleteObjectService(object) {
                window.showLoading()
                await axios.post(constants.baseApiUrl + 'Admin/AddEditDeleteFilingClassificationPlan', object)
                    .then(response => {
                        this.items = [];
                        this.closeAddEditDialog()
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading());
                this.gettingData()
            },
            GetDisabledAddFilingClassificationPlan() {
                let isValid = (utils.CheckIfNullOrEmpty(this.addEditDeleteDialogObject.name) || utils.CheckIfNullOrEmpty(this.addEditDeleteDialogObject.code));
                return isValid;
            },
            closeAddEditDialog() {
                this.showAddEditDialog = false;
                this.addEditDeleteDialogObject = {};
            },
            openDeleteDialog() {
                this.showDeleteDialog = true;
            },
            classificationPlanSelectChanged(item) {
                if (!utils.CheckIfNullOrEmpty(item))
                    this.addEditDeleteDialogObject.parentId = item.parentId
            },
            reloadComponent() {
                this.reloadFlag = !this.reloadFlag;
            },
        }

    }

</script>